import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `
   <div>
     <p>Due to winds exceeding 40 MPH, everyone must seek shelter in the main building. Operations are able to resume outdoors once winds no longer exceed the 40 MPH threshold.</p>
     <ol>
        <li>Halt all outdoor operations</li>
        <li>Confirm all onsite personnel are inside the building</li>
        <li>Ensure all personnel have been removed from docked/open trailers</li>
        <li>Confirm all onsite personnel are accounted for</li>
        <li>Once above actions are confirmed, close out the exception</li>
     </ol>
  </div>
   `
);


// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZL_Suspend_Outdoor_Operations_High_Winds.jsx